import { render, staticRenderFns } from "./PublishComment.vue?vue&type=template&id=ffbf851e&"
import script from "./PublishComment.vue?vue&type=script&lang=js&"
export * from "./PublishComment.vue?vue&type=script&lang=js&"
import style0 from "./PublishComment.vue?vue&type=style&index=0&id=ffbf851e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports